import { useDispatch, useSelector } from 'react-redux';
import { getClusters, getClustersState } from '@domain/omnichannel-budget-manager/clusters';
import { useCallback } from 'react';
import {
    getUpdatedCluster,
    getUpdatedClusterError,
    getUpdatedClusterState,
    updateCluster as updaClusterValues,
} from '@domain/omnichannel-budget-manager/update-cluster';

export const useBudgetManagerClusters = () => {
    const dispatch = useDispatch();

    const clusters = useSelector(getClusters);
    const clustersState = useSelector(getClustersState);
    const updatedCluster = useSelector(getUpdatedCluster);
    const updatedClusterState = useSelector(getUpdatedClusterState);
    const updatedClusterError = useSelector(getUpdatedClusterError);

    const updateCluster = useCallback((values) => {
        dispatch(updaClusterValues(values));
    }, [dispatch]);

    return {
        clusters,
        clustersState,
        updatedCluster,
        updatedClusterState,
        updatedClusterError,
        updateCluster,
    };
};
